import { ExternalLink } from "lucide-react";
import { LINK_PREVIEW_STATUS } from "@/lib/labels";
import { safeUrl } from "@/lib/url";

const hostOf = (u) => { try { return new URL(u).hostname.replace(/^www\./, ""); } catch { return ""; } };

// Kartu pratinjau saja, tanpa pemutar video di dalam feed: tautan selalu dibuka di situs asal
// supaya server SIST tidak menanggung beban pemutaran dan kuota pita lebar.
export function LinkCard({ link, testId = "post-link-card" }) {
  const href = safeUrl(link.url);
  const img = safeUrl(link.image_url);
  const catatan = link.status !== "ok" ? LINK_PREVIEW_STATUS[link.status] : null;
  const isi = (
    <>
      {img && (
        <div className="aspect-video w-full overflow-hidden bg-muted">
          <img src={img} alt="" loading="lazy" referrerPolicy="no-referrer" className="h-full w-full object-cover" data-testid={`${testId}-image`} />
        </div>
      )}
      <div className="space-y-1 p-3">
        <p className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
          {link.provider || hostOf(link.url) || "Tautan"}
          <ExternalLink className="h-3 w-3" aria-hidden />
        </p>
        <p className="text-sm font-semibold leading-snug" data-testid={`${testId}-title`}>
          {link.title || link.url}
        </p>
        {link.description && <p className="line-clamp-2 text-xs text-muted-foreground">{link.description}</p>}
        {catatan && <p className="text-xs text-amber-700 dark:text-amber-300" data-testid={`${testId}-notice`}>{catatan}</p>}
      </div>
    </>
  );
  if (!href) return <div className="overflow-hidden rounded-xl border text-sm" data-testid={testId}>{isi}</div>;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer nofollow" data-testid={testId}
      className="block overflow-hidden rounded-xl border bg-muted/30 text-foreground transition-colors hover:border-[#0B3D91]/40 hover:bg-muted/60">
      {isi}
    </a>
  );
}
